import { useEffect, useRef } from "react";

/*
 * O título da aba do navegador: `Clínica São Lucas · Cedentes · Boletos Maker`.
 *
 * Com link colado no chat, duas abas do painel só se distinguem por ele. Ao sair da
 * tela, volta o título anterior, e nenhuma tela seguinte herda o nome de um cedente
 * que ela não mostra.
 */
export function useTituloDoDocumento(titulo: string) {
  useEffect(() => {
    const anterior = document.title;
    document.title = `${titulo} · Boletos Maker`;
    return () => {
      document.title = anterior;
    };
  }, [titulo]);
}

/**
 * Leva o foco ao `h1` quando a tela está pronta (spec "A navegação é acessível"). O
 * `ref` vai no `h1`, com `tabIndex={-1}`.
 *
 * Quem navega por teclado precisa saber que a tela mudou, e a rota nova não diz isso
 * sozinha. Com o link direto de um painel lateral, o foco já está preso nele, e é lá
 * que ele tem de ficar: é o que o operador abriu.
 */
export function useFocoNoTitulo(pronta = true) {
  const titulo = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    if (!pronta || document.querySelector('[role="dialog"]') !== null) return;
    titulo.current?.focus({ preventScroll: true });
  }, [pronta]);

  return titulo;
}
